import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => styles(theme));

function AuthBodyButton ({ ...otherProps }) {
    const classes = useStyles();
    return (
        <Button
            classes={{
                root: classes.root,
                outlined: classes.outlined
            }}
            color="primary"
            variant="contained"
            {...otherProps}
        />
    );
}

const styles = (theme) => ({
    root: {
        height: '50px',
        borderRadius: '0px',
        width: '175px',
        fontSize: 14,
        whiteSpace: 'nowrap'
    },
    outlined: {
        border: '2px solid ' + theme.palette.primary.main + ' !important'
    }
});

export default AuthBodyButton;